export default "__VITE_ASSET__2f8eaaf4__"